import emHome from "@/views/em/Home";
import emUserCenter from "@/views/em/admin/EmUserCenter";
import emProjectCardRouters from "@/views/em/EmProjectCardRouters";
import emCardSetting from "@/components/em/EmCard/Setting";
import inspectionExecute from "@/views/em/inspection/InspectionExecute.vue";

import emRoutersAdmin from "@/router/em/admin/moduleIndex-router-em-admin";
import emRoutersAdminCustom from "@/router/em/admin/moduleIndex-router-em-admin-custom";

import emRoutersLifecycle from "@/router/em/lifecycle/moduleIndex-router-em-lifecycle";
import emRoutersArchive from "@/router/em/archive/moduleIndex-router-em-archive";
import emRoutersWorkflow from "@/router/em/workflow/moduleIndex-router-em-workflow";
import emRoutersInspection from "@/router/em/inspection/moduleIndex-router-em-inspection";
import emRoutersRepair from "@/router/em/repair/moduleIndex-router-em-repair";
import emRoutersMaintenance from "@/router/em/maintenance/moduleIndex-router-em-maintenance";
import emRoutersSpp from "@/router/em/spareparts/moduleIndex-router-em-spareparts";
import emRoutersAcct from "@/router/em/accident/moduleIndex-router-em-accident";
import emRouterKpi from "@/router/em/kpiLayout/moduleIndex-router-em-kpi";
import emRoutersOpcClient from "@/router/em/opcClient/moduleIndex-router-em-opcClient";
import emRoutersSic from "@/router/em/statusCollection/moduleIndex-router-em-statusCollection";
import emRoutersSicCustom from "@/router/em/statusCollection/moduleIndex-router-em-statusCollection-custom";
import emBaseCodeGeneration from "@/router/em/code-generation/code-generation-routes"
import alRoutes from "@/router/em/al-routes";
import emRoutersPpe from "@/router/em/ppe/moduleIndex-router-em-ppe";
import emRoutersEpc from "@/router/em/epc/moduleIndex-router-em-epc";
import emRoutersAsset from "@/router/em/asset/moduleIndex-router-em-asset";

export default [
    {path: "/em", name: "emHome", component: emHome},
    {path: "/em/emUserCenter", name: "emUserCenter", component: emUserCenter},
    {path: "/em/projectCardRouters", name: "emProjectCardRouters", component: emProjectCardRouters},
    {path: "/em/cardSetting", name: "emCardSetting", component: emCardSetting},
    {path: "/em/inspection/inspectionExecute", name: "inspectionExecute", component: inspectionExecute},
    ...emRoutersAdmin,
    ...emRoutersAdminCustom,
    ...emRoutersLifecycle,
    ...emRoutersArchive,
    ...emRoutersWorkflow,
    ...emRoutersInspection,
    ...emRoutersRepair,
    ...emRoutersSpp,
    ...emRoutersAcct,
    ...emRouterKpi,
    ...emRoutersMaintenance,
    ...emRoutersOpcClient,
    ...emRoutersSic,
    ...emRoutersSicCustom,
    ...emBaseCodeGeneration,
    ...emRoutersPpe,
    ...emRoutersEpc,
    ...emRoutersAsset,
    ...alRoutes,
]
